export const SIRET_PARTICULIER_LENGTH = 9;
export const SIRET_LENGTH = 14;
export const SPACE_CHARACTER = ' ';
export const SIRET_POSITION_3 = 3;
export const SIRET_POSITION_6 = 6;
export const SIRET_POSITION_9 = 9;
export const NIR_LENGTH = 15;
